// The published text is the same for every visitor and changes only when a new
// edition is synced into the repository, so the page is built once at build
// time. Client rendering stays on, as on the other public pages, so the top bar
// can still swap in the cabinet link for a visitor who already has a session.
export const prerender = true;
